{
  "version": 1,
  "asset_id": "e6ad941f-62b4-4a6a-9c87-fb2c989f654f",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/e6ad941f-62b4-4a6a-9c87-fb2c989f654f/crystal-river-blue-shingle-roof-destination-roofing-1200w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/e6ad941f-62b4-4a6a-9c87-fb2c989f654f/crystal-river-blue-shingle-roof-destination-roofing-1200w.avif",
  "original_filename": "crystal-river-blue-shingle-roof-destination-roofing-1200w.avif",
  "size": 57335,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:36Z"
}
